module.exports = __webpack_public_path__ + "img/app store@2x.70a2ba7b.png";